import { create } from 'zustand';
import { ChatMessage, HandHistoryEntry, TableStateSnapshot } from '../shared/types';

interface GameState {
  currentTableId: string | null;
  tableState: TableStateSnapshot | null;
  chatMessages: ChatMessage[];
  handHistory: HandHistoryEntry[];
  lastError: string | null;
  setTableId: (id: string | null) => void;
  setTableState: (s: TableStateSnapshot) => void;
  addChatMessage: (m: ChatMessage) => void;
  addHandHistory: (h: HandHistoryEntry) => void;
  setError: (e: string | null) => void;
  reset: () => void;
}

export const useGameStore = create<GameState>((set) => ({
  currentTableId: null,
  tableState: null,
  chatMessages: [],
  handHistory: [],
  lastError: null,
  setTableId: (id) => set({ currentTableId: id }),
  setTableState: (tableState) => set({ tableState }),
  addChatMessage: (m) => set((s) => ({ chatMessages: [...s.chatMessages.slice(-49), m] })),
  addHandHistory: (h) => set((s) => ({ handHistory: [h, ...s.handHistory.slice(0, 19)] })),
  setError: (lastError) => set({ lastError }),
  reset: () => set({ currentTableId: null, tableState: null, chatMessages: [], handHistory: [] }),
}));
